import Translate from '../i18n/Translate'
//Container
import Mission from '../containers/About/Mission'
import OurEssence from '../containers/About/OurEssence'
import WhyUs from '../containers/About/WhyUs'
import Sustainability from '../containers/About/Sustainability'
//Components
import OperatorsGallery from '../components/OperatorsGallery'
//Hooks
import useScrollTop from '../hooks/useScrollTop'
import useSetI18nProviderInformation from '../hooks/useSetI18nProviderInformation'
//Intersection
import { useInView } from 'react-intersection-observer'

const About = () => {
    useScrollTop()
    useSetI18nProviderInformation('about')

    const [aboutTop, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    return (
        <main className="incoming-about">
            <section className="incoming-about__top">
                <div className={`content animate slide-title ${inView ? 'in-view' : ''}`} ref={aboutTop}>
                    <h1 className="title top-title">
                        <Translate langkey="about.title" />
                    </h1>
                    <p className="copy top-subtitle">
                        <Translate langkey="about.subtitle" />
                    </p>
                </div>
            </section>

            <OurEssence />

            <Mission />

            <Sustainability />

            <WhyUs />

            <OperatorsGallery />
        </main>
    )
}

export default About
